// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumPosts__list":"th_a big_rc big_qx big_xr","ForumPosts__contest":"th_b big_hq","ForumPosts__counselling":"th_c"};